import { render, staticRenderFns } from "./HistoriesTable.vue?vue&type=template&id=6e3efed4&scoped=true&"
import script from "./HistoriesTable.vue?vue&type=script&lang=ts&"
export * from "./HistoriesTable.vue?vue&type=script&lang=ts&"
import style0 from "./HistoriesTable.vue?vue&type=style&index=0&id=6e3efed4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3efed4",
  null
  
)

export default component.exports